import React from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { useIntl } from 'react-intl';
import { nextAsset } from '../../../../components/nextAsset';
import { SmartlinksArtistPageTop } from './SmartlinksArtistPageTop';
import { SmartlinksFeatures } from '../SmartlinksFeatures';
import { Footer } from '../../../../layouts/Footer';
import { SmartlinksDescriptionArtist } from './SmartlinksDescriptionArtist';
import { SmartlinksMarketingArtist } from './SmartlinksMarketingArtist';
import { SmartlinksBrand } from '../../SmartlinksBrand';
import { SmartlinksPageExplore } from '../SmartlinksPageExplore';

/* eslint-disable react/no-danger */
export const ArtistPage: NextPage = React.memo(() => {
  const intl = useIntl();
  const title = intl.formatMessage({
    id: 'sml.web.smart-links.artist.title',
    defaultMessage: 'Artist Bio Link'
  });
  const description = intl.formatMessage(
    {
      id: 'sml.web.smart-links.artist.description',
      defaultMessage:
        'One bio link optimized for artist promotion.{br}{br} Share your music links, videos, social media, merch, tours and more on one page.'
    },
    { br: '' }
  );
  const promoImage = nextAsset(`images/smartLinks/artist/preview.png`, false, { w: 1200 });
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="twitter:title" content={title} key="twitter-title" />
        <meta property="og:title" content={title} key="fb-title" />
        <meta itemProp="description" content={description} key="itemProp-description" />
        <meta name="description" content={description} key="description" />
        <meta property="og:description" content={description} key="fb-description" />
        <meta property="twitter:description" content={description} key="twitter-description" />
        <meta itemProp="image" content={promoImage} key="image" />
        <meta property="twitter:image" content={promoImage} key="twitter-image" />
        <meta property="twitter:image:width" content="1200" key="twitter-image-width" />
        <meta property="twitter:image:height" content="600" key="twitter-image-height" />
        <meta property="og:image" content={promoImage} key="fb-image" />
      </Head>
      <SmartlinksArtistPageTop />
      <SmartlinksDescriptionArtist />
      <SmartlinksMarketingArtist />
      <SmartlinksBrand subPageName="Artist Bio Link" />
      <SmartlinksFeatures />
      <SmartlinksPageExplore hideArtist subPageName="Artist Bio Link" />
      <Footer />
    </>
  );
});
